import React, { createContext, useContext } from 'react';

export type ContentApiScope =
	| { mode: 'legacy' }
	| { mode: 'standalone-lecture'; lectureId: number };

const LEGACY_SCOPE: ContentApiScope = { mode: 'legacy' };
let activeApiScope: ContentApiScope = LEGACY_SCOPE;

export const setContentApiScope = (scope: ContentApiScope) => {
	activeApiScope = scope;
};

export const clearContentApiScope = (lectureId: number) => {
	if (
		activeApiScope.mode === 'standalone-lecture' &&
		activeApiScope.lectureId === lectureId
	) {
		activeApiScope = LEGACY_SCOPE;
	}
};

export const getContentApiScope = () => activeApiScope;

const ContentModeContext = createContext<ContentApiScope>(LEGACY_SCOPE);

export const ContentModeProvider: React.FC<{ scope: ContentApiScope }> = ({
	scope,
	children,
}) => (
	<ContentModeContext.Provider value={scope}>
		{children}
	</ContentModeContext.Provider>
);

export const useContentMode = () => useContext(ContentModeContext);

export const useIsStandaloneLecture = () =>
	useContentMode().mode === 'standalone-lecture';
